import { useBooleanFlag } from '@trm/feature-flags/web';

export const useKycReviewAssistFlag = () => ({
  kycReviewAssistEnabled: useBooleanFlag('enable-kyc-review-assist', false),
});
